import { ApiService } from 'api';
import { ResponsibleNewUserData } from 'dashboard409a/pages/Information/InformationRequestModal/CreateNewUserDialog/types';
import { manageApiRequest } from 'hooks/apiRequest';

interface HandleAddUserProps {
  userData: ResponsibleNewUserData;
  currentCompanyId: number;
  handleDialogClose: (newUserId: number) => void;
}

const addCompanyUserToCompanyDashboard = async ({ userData, currentCompanyId, handleDialogClose }: HandleAddUserProps) => {
  if (currentCompanyId) {
    const result = await manageApiRequest(
      ApiService.apiDashboardCompanyAddUserCreate({
        company_id: currentCompanyId,
        email: userData.email,
        first_name: userData.firstName,
        last_name: userData.lastName,
        is_primary_contact: !!userData.isPrimaryContact,
        send_activation_email: !!userData.sendActivationEmail,
      })
    )
    if (result && result.id !== undefined) {
      return handleDialogClose(result.id);
    }
  }
  return null;
}

export default addCompanyUserToCompanyDashboard;
